import { Denuncia } from "./Denuncia";

export class Acuerdo {
  /*constructor() {
    this.faltaAdministrativaId = 0;
    this.estatusFaltaAdministrativaId = -1;
    this.fechaDeRecepcion = null;
    this.denunciante = "";
    this.presuntoResponsable = "";
    this.adscripcion = "";
    this.actoReclamado = "";
    this.calificacionId = -1;
    this.fechaInforme = null;
    this.fechaDevolucion = null;
    this.extracto = ""
  }*/
  constructor(
    acuerdoId = 0,
    fechaDeDictado = null,
    fechaDePublicacion = null,
    extracto = "",
    rutaDeArchivo = "",
    denunciaId = 0,
    usuarioRegistroId = 6,
    fechaDeRegistro = null,
    listaDeAcuerdosId = null,
    activo = 1,
    denuncia = null,
    promociones = null
  ) {
    this.acuerdoId = acuerdoId,
      this.fechaDeDictado = fechaDeDictado;
    this.fechaDePublicacion = fechaDePublicacion;
    this.extracto = extracto;
    this.rutaDeArchivo = rutaDeArchivo;
    this.denunciaId = denunciaId;
    this.usuarioRegistroId = usuarioRegistroId;
    this.fechaDeRegistro = fechaDeRegistro;
    this.listaDeAcuerdosId = listaDeAcuerdosId;
    this.activo = activo;
    this.denuncia = denuncia;
    this.promociones = promociones;
  }
  constructorObjeto(acuerdoObject) {
    this.acuerdoId = acuerdoObject.acuerdoId,
      this.fechaDeDictado = acuerdoObject.fechaDeDictado.substring(0, 10);
    this.fechaDePublicacion = acuerdoObject.fechaDePublicacion.substring(0, 10);
    this.extracto = acuerdoObject.extracto;
    this.rutaDeArchivo = acuerdoObject.rutaDeArchivo;
    this.denunciaId = acuerdoObject.denunciaId;
    this.usuarioRegistroId = acuerdoObject.usuarioRegistro_001DBCUENTAS;
    this.fechaDeRegistro = acuerdoObject.fechaDeRegistro;
    this.listaDeAcuerdosId = acuerdoObject.listaDeAcuerdosId;
    this.activo = acuerdoObject.activo;
    this.denuncia = (() => {
      let nuevaDenuncia = new Denuncia();
      nuevaDenuncia.constructorObjeto(acuerdoObject.denuncia);
      return nuevaDenuncia;
     })();
    this.promociones = acuerdoObject.promociones;
  }
  cargarDenuncia(denuncia) {
    
   }
}



// WEBPACK FOOTER //
// ./src/components/SIFA/Comun/Modelos/Acuerdo.js